import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';
import IdleTimer from 'react-idle-timer';
import isApp from '../../utils/isApp';

const IdleTimeout = ({ loading, user, config, actions }) => {
    const idleTimerRef = useRef(null);
    const [auto_terminate, setAutoTerminate] = useState(
        config.config.auto_terminate_seconds
    );

    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
        if (config.config) {
            setAutoTerminate(config.config.auto_terminate_seconds);
        }
    }, [config]);

    const timeout =
        auto_terminate !== ''
            ? parseInt(auto_terminate, 10) * 1000
            : 180000;

    if (
        !hasMounted ||
        loading.actions['getPlayerData'] ||
        loading.actions['getConfig']
    ) {
        return null;
    } else {
        return user.loggedIn && !isApp() && timeout ? (
            <>
                <IdleTimer
                    ref={idleTimerRef}
                    onIdle={() => {
                        // user has been idle for auto_terminate_seconds * 1000
                        console.log('User timed out');
                        actions.userActions.logout();
                    }}
                    timeout={timeout}
                />
            </>
        ) : null;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(IdleTimeout);
